import { FC, useContext, useEffect } from "react";
import { EnterpriseComplianceDashboardContext } from "../contexts/EcdContext";
import { EnterpriseComplianceFiltersContext } from "../contexts/EcdFiltersContext";
import { EcdTilesEnum } from "../interfaces";
import CountyStatusTable from "../components/CountyStatusTable";
import DashboardTile from "@app/shared/qes-standards/DashboardTile";

const CountyStatusOverview: FC = () => {
    const filtersContext = useContext(EnterpriseComplianceFiltersContext);
    const dashboardContext = useContext(EnterpriseComplianceDashboardContext);

    useEffect(() => {
        dashboardContext.updateIsTileLoadingMap(EcdTilesEnum.CountyStatusOverview, true);
    }, []);

    useEffect(() => {
        if (dashboardContext.countyStatusData?.length > 0) {
            dashboardContext.updateIsTileLoadingMap(EcdTilesEnum.CountyStatusOverview, false);
        }
    }, [dashboardContext.countyStatusData]);

    useEffect(() => {
        if (!!filtersContext.apiReadyFilters) {
            dashboardContext.updateIsTileLoadingMap(EcdTilesEnum.CountyStatusOverview, true);
        }
    }, [filtersContext.apiReadyFilters]);

    return (
        <DashboardTile
            loading={filtersContext.isDashboardLoading || dashboardContext.isTileLoadingMap.get(EcdTilesEnum.CountyStatusOverview)}
            title="County Status Overview"
            widthClass="col-md-12 col-xl-6"
        >
          <CountyStatusTable tableData={ dashboardContext.countyStatusData } />
        </DashboardTile>
    )
}

export default CountyStatusOverview;